import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import {
  EntityName,
  EventType,
  SectionName,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { JumpPageSectionProps } from '../jump-page-body';

const EtcSection: React.FC<JumpPageSectionProps> = ({
  analytics: { navigationId },
}) => {
  const theme = useTheme();
  const { ref } = useImpressionEvent({
    navigationId,
    eventType: EventType.ElementImpression,
    payload: {
      entity_name: EntityName.JumpPersRecsRatings,
      section_name: SectionName.JumpPersRecsRatings,
      section_position: 3,
    },
  });
  return (
    <Box
      ref={ref}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      bgcolor="green.main"
      padding={4}
      sx={{ [theme.breakpoints.down('sm')]: { paddingX: 3 } }}
    >
      <Typography
        color={theme.palette.common.white}
        textAlign="center"
        marginBottom={2}
        variant="bodyLargeBlack"
      >
        Personalized recommendations. Objective ratings.
      </Typography>
      <Typography
        color="common.white"
        textAlign="center"
        variant="text"
        sx={{ [theme.breakpoints.up('sm')]: { maxWidth: '66.6%' } }}
      >
        We’ve combed through countless stacks of credit cards. We’ll show you
        the best cards for you and your needs — along with our objective rating
        of each card.
      </Typography>
    </Box>
  );
};

export default EtcSection;
